import ProxyBase from '../../../../core/proxies/ProxyBase'

class SummaryProxy extends ProxyBase {
  getTemplates(params) {
    return this.get('Summary/Templates', params, undefined, true)
  }
  getTemplateDetail(params) {
    return this.get('Summary/TemplateDetail', params)
  }
  setDefaultTemplate(params) {
    return this.post('Summary/SetDefaultTemplate', params)
  }
  deleteTemplates(params) {
    return this.delete('Summary/DeleteTemplate', params)
  }
  updateTemplate(params) {
    return this.post('Summary/UpdateTemplate', params)
  }
  saveTemplate(params) {
    return this.post('Summary/SaveTemplate', params)
  }
  getDefaultTemplate(params) {
    return this.get('Summary/DefaultTemplate', params, undefined, true)
  }
  getSummaryHighlight(params) {
    return this.get('Summary/SummaryHightlight', params)
  }
  getSummaryOverview(params) {
    return this.get('Summary/SummaryOverView', params)
  }
  getOwnershipAndGroupInfo(params) {
    return this.get('OwnershipAndGroup/Hightlight', params)
  }
  getOwnershipAndGroup(params) {
    return this.get('Summary/OwnershipAndGroup', params)
  }
  getKeyFinancials(params) {
    return this.post('Summary/KeyFinancials', params)
  }
  getScore(params) {
    return this.get('Summary/Score', params)
  }
  getRecentNews(params) {
    return this.get('Summary/NewsAndSocials', params)
  }
  getAlertHighlight(params) {
    return this.post('Alert/AlertStatistic', params)
  }
  getCompanyAlerts(params) {
    return this.post('Summary/AlertList', params)
  }
  getRevenue(params) {
    return this.post('Summary/Revenue', params)
  }
  getIndustryTopYear(params) {
    return this.get('IndustryOverview/TopYear', params)
  }
  getTopIndustryPlayers(params) {
    return this.get('Summary/TopPlayers', params)
  }
  getTopComparablePlayers(params) {
    return this.get('Summary/GetTopComparablePlayers', params)
  }
  downloadTopComparablePlayers(params) {
    return this.post(
      'Summary/GetTopComparablePlayers/Export',
      params,
      {},
      'download',
    )
  }
  getFilingStatus(params) {
    return this.get('Summary/FilingStatus', params)
  }
}

export default new SummaryProxy()
